<template>
  <div class="contracts-list-inner">
    <v-card
      v-for="contract in contracts"
      :key="contract.myp_id"
      class="contract-card"
      elevation="1"
    >
      <v-card-text>
        <div class="contract-header">
          <div class="contract-title-block">
            <h2 class="contract-name">
              {{ contract.prod_name || 'Unbenanntes Produkt' }}
            </h2>
            <p class="contract-subtitle">
              Vertrag-ID #{{ contract.myp_id }} · Produkt-ID #{{ contract.myp_product_id }}
            </p>
          </div>

          <div class="contract-meta-right">
            <div
              v-if="contract.myp_created_date && contract.myp_created_date !== '1973-01-01 00:00:00'"
              class="contract-created"
            >
              <v-icon size="16" color="#666" class="mr-1">mdi-calendar</v-icon>
              <span>seit {{ formatDateShort(contract.myp_created_date) }}</span>
            </div>
          </div>
        </div>

        <div class="contract-actions">
          <router-link :to="{ name: 'vertrag', params: { id: contract.myp_id } }">
            <v-btn
              color="#EA5545"
              variant="flat"
              size="small"
              class="open-contract-btn"
            >
              <v-icon left size="18">mdi-file-document</v-icon>
              Vertrag öffnen
            </v-btn>
          </router-link>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  contracts: {
    type: Array,
    required: true
  }
})

const contracts = computed(() => props.contracts)

function formatDateShort(dateString) {
  if (!dateString || dateString === '1973-01-01 00:00:00') return 'N/A'
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return dateString
  return date.toLocaleDateString('de-DE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  })
}
</script>

<style scoped src="@/assets/styles/sfc/components/objects/ContractList.css"></style>
